import axiosInstance from "../Services/Api/axiosInstance";

export const fetchQuestionnaires = async () => {
    try {
        const response = await axiosInstance.get('/vendorlist');
        return {
            message: response.data.message,
            questionnaires: response.data.data,
            userInfo: response.data.userInfo
        };
    }
    catch (error) {
        console.error("Error fetching questionnaires:", error);
        throw new Error(error.response?.data?.message || "Error fetching questionnaires");
    }
}
export const fetchQuestions = async (questionnaireId) => {
    try {
        const response = await axiosInstance.get(`/questionnaire/${questionnaireId}`);
        const finalResult = response.data.data;

        // Sort the results
        finalResult.sort((a, b) => {
            const aOrder = a.pirm_addon__Question__r?.pirm_addon__Template__r?.pirm_addon__Order__c;
            const bOrder = b.pirm_addon__Question__r?.pirm_addon__Template__r?.pirm_addon__Order__c;
            const aParentTemplate = a.pirm_addon__Question__r?.pirm_addon__Template__r?.pirm_addon__Parent_Template__c;
            const bParentTemplate = b.pirm_addon__Question__r?.pirm_addon__Template__r?.pirm_addon__Parent_Template__c;

            if (!aParentTemplate && bParentTemplate) return -1;
            if (aParentTemplate && !bParentTemplate) return 1;
            if (aOrder == null && bOrder == null) return 0;
            if (aOrder == null) return 1;
            if (bOrder == null) return -1;

            const templateOrderDiff = aOrder - bOrder;
            if (templateOrderDiff !== 0) return templateOrderDiff; // different templates, stop here

            // Same template → sort by question order
            const questionOrderA = parseInt(a.pirm_addon__Question_Order__c, 10) || 0;
            const questionOrderB = parseInt(b.pirm_addon__Question_Order__c, 10) || 0;
            return questionOrderA - questionOrderB;
        });

        return finalResult;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error fetching questionnaire");
    }
};

export const updateQuestionnaireAnswers = async (id, auditId, action, payload) => {
    try {
        const response = await axiosInstance.post(
            `/UpdateAnswer/${id}/${auditId}?action=${action}`,
            payload
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error updating answers");
    }
};

export const uploadQuestionnaireFile = async (payload) => {
    try {
        const response = await axiosInstance.post('/UpdateAnswer/files', payload);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error uploading file");
    }
};

export const deleteQuestionnaireFile = async (docId) => {
    try {
        const response = await axiosInstance.delete(`/delete/file/${docId}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error deleting file");
    }
};